export const emrMenuDef = [
  {
    "name": "menu.care_plan",
    "resource": "ip_ward_consumable_highly",
    "icon": "fa fa-plus-square",
    "url": "ip_ward_consumable_highly",
    "auto_crud": true,
    "breadcrumb": "pathology",
    "showMenu": false,
    "check_permission": false
  },
  {
    "name": "menu.care_plan",
    "resource": "ip_ward_consumable_highly_sub_form",
    "icon": "fa fa-plus-square",
    "url": "ip_ward_consumable_highly_sub_form",
    "auto_crud": true,
    "breadcrumb": "pathology",
    "showMenu": false,
    "check_permission": false
  },
  {
    "name": "m.submitted_bill_queries",
    "resource": "submitted_bill_queries",
    "icon": "fa fa-user-md",
    "url": "submitted_bill_queries",
    "check_permission": false,
    "auto_crud": true,
    "breadcrumb": "Queries"
  },
  {
    "name": "m.patient_assigned_protocols",
    "resource": "patient_assigned_protocols",
    "icon": "fa fa-user-md",
    "url": "patient_assigned_protocols",
    "check_permission": false,
    "auto_crud": true,
    "breadcrumb": "Queries"
  },
  {
    "name": "menu.toxicity_monitoring",
    "resource": "toxicity_monitoring",
    "icon": "fa fa-user-md",
    "url": "toxicity_monitoring",
    "check_permission": false,
    "auto_crud": true,
    "breadcrumb": "Queries"
  },
  {
    "name": "menu.care_plan",
    "resource": "care_plan",
    "icon": "fa fa-plus-square",
    "url": "care_plan",
    "auto_crud": true,
    "breadcrumb": "pathology",
    "showMenu": false
  },
  {
    "name": "menu.gynec_history",
    "resource": "gynec_history",
    "icon": "fa fa-plus-square",
    "url": "gynec_history",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    name: 'menu.reimbursement_format',
    resource: "reimbursement_format",
    icon: 'fa fa-h-square',
    url: 'reimbursement_format',
    check_permission: false,
    auto_crud: true,
    showMenu: true
  },
  {
    name: 'menu.patient_submitted_bill',
    resource: "patient_submitted_bill",
    icon: 'fa fa-h-square',
    url: 'patient_submitted_bill',
    check_permission: false,
    auto_crud: true,
    showMenu: true
  },
  {
    name: 'menu.reimbursement_patient',
    resource: "reimbursement_patient",
    icon: 'fa fa-h-square',
    url: 'reimbursement_patient',
    check_permission: false,
    auto_crud: true,
    showMenu: true
  },
  {
    "name": "menu.patient_orientation",
    "resource": "patient_orientation",
    "icon": "fa fa-plus-square",
    "url": "patient_orientation",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.psychosocial_history",
    "resource": "psychosocial_history",
    "icon": "fa fa-plus-square",
    "url": "psychosocial_history",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": "menu.insertion_details",
    "resource": "removal_details",
    "icon": "fa fa-plus-square",
    "url": "insertion_details",
    "auto_crud": true,
    "breadcrumb": "",
    "showMenu": false
  },
  {
    "name": 'menu.view_medical_records',
    "resource": "view_medical_records",
    "icon": 'fa fa-h-square',
    "url": 'view_medical_records',
    "check_permission": false,
    "auto_crud": true,
    "showMenu": true
  },
  {
    "name": 'menu.health_assessment_records_format',
    "resource": "health_assessment_records_format",
    "icon": 'fa fa-h-square',
    "url": 'health_assessment_records_format',
    "check_permission": false,
    "auto_crud": true,
    "showMenu": true
  },
  {
    "name": 'menu.work_injury_report',
    "resource": "work_injury_report",
    "icon": 'fa fa-h-square',
    "url": 'work_injury_report',
    "check_permission": false,
    "auto_crud": true,
    "showMenu": true
  },
  {
    "name": "menu.template_documents",
    "resource": "emr_patient_assessment",
    "icon": "fa fa-tag",
    "url": "emr_patient_assessment",
    "auto_crud": true,
    "breadcrumb": "Template Documents",
    "check_permission": true,
    "showMenu": true
  },
  {
    "name": "menu.pathology",
    "resource": "pathologyDefinition",
    "icon": "fa fa-plus-square",
    "url": "pathologyDefinition",
    "auto_crud": true,
    "breadcrumb": "pathology",
    "showMenu": false
  },
  {
    "name": "menu.removal_details",
    "resource": "removal_details",
    "icon": "fa fa-user-md",
    "url": "removal_details",
    "auto_crud": true,
    "breadcrumb": "Patient List",
    "showMenu": false
  }, {
    "name": "menu.maintenance_details",
    "resource": "maintenance_details",
    "icon": "fa fa-user-md",
    "url": "maintenance_details",
    "auto_crud": true,
    "breadcrumb": "Patient List",
    "showMenu": false
  },
  {
    "name": "menu.removal_details",
    "resource": "episode_history_format",
    "icon": "fa fa-user-md",
    "url": "episode_history_format",
    "auto_crud": true,
    "breadcrumb": "Patient List",
    "showMenu": false
  },
  {
    "name": "menu.diagnosis",
    "resource": "condition_diagnosis",
    "icon": "fa fa-plus-square",
    "url": "condition_diagnosis",
    "auto_crud": true,
    "breadcrumb": "diagnosis",
    "showMenu": false
  },
  {
    "name": "menu.medicine_order",
    "resource": "emr_medicationRequest",
    "icon": "fa fa-plus-square",
    "url": "emr_medicationRequest",
    "auto_crud": true,
    "breadcrumb": "medicine-request",
    "showMenu": false
  },
  {
    name: 'menu.trend',
    resource: 'health_assessment_trend',
    icon: "fa fa-plus-square",
    url: 'health_assessment_trend',
    showMenu: false,
    auto_crud: true
  },
  {
    "name": "menu.miscellaneous",
    "resource": "insurance_billing_item_miscllaneous",
    "icon": "fa fa-user",
    "url": "insurance_billing_item_miscllaneous",
    "auto_crud": true,
    "breadcrumb": "Miscellaneous",
    "showMenu": false
  },
  {
    "name": "menu.emr_format",
    "resource": "emr_format",
    "icon": "fa fa-plus-square",
    "url": "emr_format",
    "auto_crud": true,
    "breadcrumb": "Patient EMR View",
    "showMenu": false,
    "check_permission": false
  },
  {
    "name": "menu.emr_format_patient",
    "resource": "emr_format_patient",
    "icon": "fa fa-plus-square",
    "url": "emr_format_patient",
    "auto_crud": true,
    "breadcrumb": "Patient EMR View",
    "showMenu": false,
    "check_permission": false
  },
  {
    "name": "m.outside_referral",
    "resource": "outside_referral_format",
    "icon": "fa fa-user-md",
    "url": "outside_referral_format",
    "check_permission": false,
    "auto_crud": true,
    "breadcrumb": "Out Side Referral Request"
  },
  {
    "name": "m.outside_referral",
    "resource": "outside_refer",
    "icon": "fa fa-user-md",
    "url": "outside_refer",
    "check_permission": false,
    "auto_crud": true,
    "breadcrumb": "Out Side Referral Request"
  },
  {
    "name": "m.outside_referral",
    "resource": "outside_refer",
    "icon": "fa fa-user-md",
    "url": "outside_completed_referred",
    "check_permission": false,
    "auto_crud": true,
    "breadcrumb": "Out Side Referral Request"
  },
  {
    "name": "m.inter_facility_referral_request",
    "resource": "inter_facility_referral_request",
    "icon": "fa fa-user-md",
    "url": "inter_facility_referral_request",
    "check_permission": false,
    "auto_crud": true,
    "breadcrumb": "Inter Facility Referral Request"
  },
  {
    "name": "m.inter_facility_referral_request",
    "resource": "inter_facility_referral_request_view",
    "icon": "fa fa-user-md",
    "url": "inter_facility_referral_request_view",
    "check_permission": false,
    "auto_crud": true,
    "breadcrumb": "Inter Facility Referral Request"
  },
  {
    "name": "m.rejected_referral_request",
    "resource": "rejected_referral_request",
    "icon": "fa fa-user-md",
    "url": "rejected_referral_request",
    "check_permission": false,
    "auto_crud": true,
    "breadcrumb": "Rejected Referral Request"
  },
  {
    "name": "menu.corporate_booking",
    "resource": "corporate_booking",
    "icon": "fa fa-plus-square",
    "url": "corporate_booking",
    "auto_crud": true,
    "showMenu": false,
    "check_permission": false
  },
  {
    "name": "m.episode_print_record",
    "resource": "episode_print_record",
    "icon": "fa fa-user-md",
    "url": "episode_print_record",
    "check_permission": false,
    "auto_crud": true,
    "breadcrumb": "Episode Print Record"
  },
  {
    "name": "Health Assessment",
    "resource": "health_assessment_add",
    "icon": "fa fa-user-md",
    "url": "health_assessment_add",
    "auto_crud": true,
    "showMenu": false
  },
  {
    "name": "Health Assessment",
    "resource": "health_assessment_package_add",
    "icon": "fa fa-user-md",
    "url": "health_assessment_package_add",
    "auto_crud": true,
    "showMenu": false
  },
  {
    "name": "menu.my_patients",
    "icon": "fa fa-plus-square",
    "data": {
      "nav_url": "patientlist_format_m"
    },
    "children": [
      {
        "name": "menu.op_ip_er_patients",
        "resource": "patientlist_format",
        "icon": "fa fa-user-md",
        "url": "patientlist_format",
        "auto_crud": true,
        "breadcrumb": "Patient List ",
        "check_permission": true
      },
      {
        "name": "field.label.cryopreservation",
        "resource": "cryopreservation_format",
        "icon": "fa fa-user-md",
        "url": "cryopreservation_format",
        "auto_crud": true,
        "breadcrumb": "Cryopreservation",
        "check_permission": true,
      },
      {
        "name": "field.label.cryopreservation",
        "icon": "fa fa-user-md",
        "url": "cryopreservation_store",
        "auto_crud": true,
        "breadcrumb": "Cryopreservation",
        "check_permission": false,
        "resource": "cryopreservation_store"
      },
      {
        "name": "field.label.cryostore_sperm_detail_view",
        "icon": "fa fa-user-md",
        "url": "cryostore_sperm_detail_view",
        "auto_crud": true,
        "breadcrumb": "Cryopreservation",
        "check_permission": false,
        "resource": "cryostore_sperm_detail_view"
      },
      {
        "name": "field.label.cryostore_sperm_detail_self_view",
        "icon": "fa fa-user-md",
        "url": "cryostore_sperm_detail_self_view",
        "auto_crud": true,
        "breadcrumb": "Cryopreservation",
        "check_permission": false,
        "resource": "cryostore_sperm_detail_self_view"
      },
      {
        "name": "field.label.cryostore_oocyte_detail_view",
        "icon": "fa fa-user-md",
        "url": "cryostore_oocyte_detail_view",
        "auto_crud": true,
        "breadcrumb": "Cryopreservation",
        "check_permission": false,
        "resource": "cryostore_oocyte_detail_view"
      },
      {
        "name": "field.label.cryostore_embryo_detail_view",
        "icon": "fa fa-user-md",
        "url": "cryostore_embryo_detail_view",
        "auto_crud": true,
        "breadcrumb": "Cryopreservation",
        "check_permission": false,
        "resource": "cryostore_embryo_detail_view"
      },


      {
        "name": "field.label.cryopreservation_virtification",
        "icon": "fa fa-user-md",
        "url": "cryopreservation_virtification",
        "auto_crud": true,
        "breadcrumb": "Cryopreservation",
        "check_permission": false,
        "resource": "cryopreservation_virtification"
      },
      {
        "name": "Referral Patient",
        "resource": "emr_referral_requests",
        "icon": "fa fa-user-md",
        "url": "emr_referral_requests",
        "check_permission": true,
        "auto_crud": true,
        "breadcrumb": "Patient List "
      },
      {
        "name": "menu.requested_services",
        "resource": "servicerequest",
        "icon": "fa fa-user-md",
        "url": "servicerequest",
        "auto_crud": true,
        "breadcrumb": "Requested Services",
        "showMenu": false
      },
      {
        "name": "menu.nurse",
        "resource": "nurseservicerequest",
        "icon": "fa fa-user-md",
        "url": "nurseservicerequest",
        "auto_crud": true,
        "showMenu": false
      },
      {
        "name": "menu.diagnosis",
        "resource": "condition_diagnosis",
        "icon": "fa fa-plus-square",
        "url": "condition_diagnosis",
        "auto_crud": true,
        "breadcrumb": "diagnosis",
        "showMenu": false
      },
      {
        "name": "menu.allergies",
        "resource": "allergy_intolerance",
        "icon": "fa fa-plus-square",
        "url": "allergy_intolerance",
        "auto_crud": true,
        "breadcrumb": "allergies",
        "showMenu": false
      },
      {
        "name": "menu.transfer_request",
        "resource": "encounter_transfer",
        "icon": "fa fa-plus-square",
        "url": "encounter_transfer",
        "auto_crud": true,
        "breadcrumb": "transfer",
        "showMenu": false
      },
      {
        "name": "menu.package_details",
        "resource": "billing_package_details",
        "icon": "fa fa-user",
        "url": "billing_package_details",
        "auto_crud": true,
        "breadcrumb": "Package Details",
        "showMenu": false
      },
      {
        "name": "menu.initiate_discharge",
        "resource": "encounter_initiateDischarge",
        "icon": "fa fa-plus-square",
        "url": "encounter_initiateDischarge",
        "auto_crud": true,
        "breadcrumb": "initiate-discharge",
        "showMenu": false
      },
      {
        "name": "menu.nursing_clearance",
        "resource": "nursing_clearance",
        "icon": "fa fa-plus-square",
        "url": "nursing_clearance",
        "auto_crud": true,
        "breadcrumb": "nursing-clearance",
        "showMenu": false
      },
      {
        "name": "menu.discharge_intimation_unacknowledge",
        "resource": "dischargeIntimation",
        "icon": "fa fa-plus-square",
        "url": "dischargeIntimation",
        "auto_crud": true,
        "breadcrumb": "discharge-intimation",
        "showMenu": false
      },
      {
        "name": "menu.bed_vacant",
        "resource": "bed_vacant",
        "icon": "fa fa-plus-square",
        "url": "bed_vacant",
        "auto_crud": true,
        "breadcrumb": "bed-vacant",
        "showMenu": false
      },
      {
        "name": "menu.discharge_summary_prepared",
        "resource": "dischargeSummary_prepared",
        "icon": "fa fa-plus-square",
        "url": "dischargeSummary_prepared",
        "auto_crud": true,
        "breadcrumb": "discharge-summary-prepared",
        "showMenu": false
      },
      {
        "name": "menu.emr_referral_request_format",
        "resource": "emr_referral_request_format",
        "icon": "fa fa-user-md",
        "url": "emr_referral_request_format",
        "check_permission": true,
        "auto_crud": true,
        "breadcrumb": "Patient List "
      },
      {
        name: 'menu.pre_authorization_request_approved',
        resource: 'pre_authorization_request_approved',
        icon: 'fa fa-plus-square',
        url: 'pre_authorization_request_approved',
        check_permission: false,
        auto_crud: true,
        showMenu: true,
      },
      {
        name: 'menu.authorization_request_approved',
        resource: 'authorization_request_approved',
        icon: 'fa fa-plus-square',
        url: 'authorization_request_approved',
        check_permission: false,
        auto_crud: true,
        showMenu: true,
      },
      {
        "name": "m.referral_request_approval_pre_authorization",
        "resource": "referral_request_approval",
        "icon": "fa fa-user-md",
        "url": "referral_request_approval_pre_authorization",
        "check_permission": false,
        "auto_crud": true,
        "breadcrumb": "Pre-Authorization"
      },
      {
        "name": "m.referral_request_approval",
        "resource": "referral_request_approval",
        "icon": "fa fa-user-md",
        "url": "referral_request_approval",
        "check_permission": false,
        "auto_crud": true,
        "breadcrumb": "Approved Referral Request"
      },
      {
        name: 'menu.submitted_bill',
        resource: 'insurance_billing_preauth',
        icon: 'fa fa-plus-square',
        url: 'insurance_billing_preauth',
        check_permission: false,
        auto_crud: true,
        showMenu: true
      },
      {
        name: 'menu.submitted_bill',
        resource: 'view_referral_request_form',
        icon: 'fa fa-plus-square',
        url: 'view_referral_request_form',
        auto_crud: true,
        check_permission: false,
        showMenu: true
      },
      {
        name: 'menu.referral_request_history',
        resource: 'referral_request_history',
        icon: 'fa fa-plus-square',
        url: 'referral_request_history',
        check_permission: false,
        auto_crud: true,
        showMenu: true
      },
      {
        name: 'menu.submitted_bill',
        resource: 'insurance_billing',
        icon: 'fa fa-plus-square',
        url: 'insurance_billing',
        check_permission: false,
        auto_crud: true,
        showMenu: true
      },
      {
        name: 'menu.submitted_bill',
        resource: 'queries_insurance_billing',
        icon: 'fa fa-plus-square',
        url: 'queries_insurance_billing',
        check_permission: false,
        auto_crud: true,
        showMenu: true
      },
      {
        "name": "m.referral_request_approval_queries",
        "resource": "referral_request_approval",
        "icon": "fa fa-user-md",
        "url": "referral_request_approval_queries",
        "check_permission": false,
        "auto_crud": true,
        "breadcrumb": "Queries"
      },
      {
        "name": "m.referral_request_approval_answered",
        "resource": "referral_request_approval",
        "icon": "fa fa-user-md",
        "url": "referral_request_approval_answered",
        "check_permission": false,
        "auto_crud": true,
        "breadcrumb": "Answered"
      },
      {
        "name": "m.referral_request_approval_enhanced",
        "resource": "referral_request_approval",
        "icon": "fa fa-user-md",
        "url": "referral_request_approval_enhanced",
        "check_permission": false,
        "auto_crud": true,
        "breadcrumb": "Pre-Authorization"
      },
      {
        name: 'menu.submitted_bill',
        resource: 'insurance_billing_approved',
        icon: 'fa fa-plus-square',
        url: 'insurance_billing_approved',
        check_permission: false,
        auto_crud: true,
        showMenu: true
      },
      {
        name: 'menu.reimbursement_request',
        resource: 'reimbursement_request',
        icon: 'fa fa-plus-square',
        url: 'reimbursement_request',
        check_permission: false,
        auto_crud: true,
        showMenu: true
      },
      {
        name: 'menu.patient_insurance_billing_item_miscllaneous',
        resource: 'patient_insurance_billing_item_miscllaneous',
        icon: 'fa fa-plus-square',
        url: 'patient_insurance_billing_item_miscllaneous',
        check_permission: false,
        auto_crud: true,
        showMenu: true
      }
    ]
  },
  {
    "name": "menu.my_favourites",
    "icon": "fa fa-plus-square",
    "data": {
      "nav_url": "casesheet_master_m"
    },
    "children": [
      {
        "name": "menu.my_casesheet",
        "resource": "casesheet_master",
        "icon": "fa fa-user-md",
        "url": "casesheet_master",
        "auto_crud": true,
        "breadcrumb": "CaseSheet Master",
        "check_permission": false
      },
      {
        "name": "menu.emr_default_store",
        "resource": "emr_default_store",
        "icon": "fa fa-user-md",
        "url": "emr_default_store",
        "auto_crud": true,
        "breadcrumb": "Default Store",
        "check_permission": false
      },
      {
        "name": "menu.my_advisedtasks_",
        "resource": "advice_task_master",
        "icon": "fa fa-user-md",
        "url": "advice_task_master",
        "auto_crud": true,
        "breadcrumb": "Requested Services",
        "check_permission": false
      },
      {
        "name": "menu.discharge_type_master",
        "resource": "discharge_summary_master",
        "icon": "fa fa-user-md",
        "url": "discharge_summary_master",
        "auto_crud": true,
        "breadcrumb": "Discharge Type Master",
        "check_permission": false,
        "showMenu": false
      },
      {
        "name": "menu.medicine_error_log",
        "resource": "medicine_error_log",
        "icon": "fa fa-user-md",
        "url": "medicine_error_log",
        "auto_crud": true,
        "breadcrumb": "Medicine Error Log",
        "check_permission": false
      },
      {
        "name": "menu.folder_master",
        "resource": "folder_document",
        "icon": "fa fa-user-md",
        "url": "folder_document",
        "auto_crud": true,
        "breadcrumb": "Folder Master",
        "check_permission": false,
        "showMenu": true
      },
      {
        "name": "menu.patient_document",
        "resource": "file_document",
        "icon": "fa fa-user-md",
        "url": "file_document",
        "auto_crud": false,
        "breadcrumb": "Patient Document",
        "check_permission": false,
        "showMenu": false
      },
      {
        "name": "menu.doctors_favourite",
        "resource": "doctors_favourite",
        "icon": "fa fa-user-md",
        "url": "doctors_favourite",
        "auto_crud": true,
        "breadcrumb": "Doctors Favourite",
        "check_permission": false,
        "showMenu": true
      },

      {
        "name": "menu.vitalsaddprogres",
        "resource": "vitals_details",
        "icon": "fa fa-user-md",
        "url": "vitals",
        "auto_crud": false,
        "breadcrumb": "Vitals Add Progress",
        "check_permission": false,
        "showMenu": false
      },
      {
        "name": "menu.vitalsviewprog",
        "resource": "vitals_details",
        "icon": "fa fa-user-md",
        "url": "vitals-view",
        "auto_crud": false,
        "breadcrumb": "Vitals View Progress",
        "check_permission": false,
        "showMenu": false
      },
      {
        "name": "menu.order_set",
        "resource": "order_set",
        "icon": "fa fa-user-md",
        "url": "order_set",
        "auto_crud": true,
        "breadcrumb": "Order Set",
        "check_permission": false,
        "showMenu": true
      },
      {
        "name": "menu.order_set",
        "resource": "order_set_doctor",
        "icon": "fa fa-user-md",
        "url": "order_set_doctor",
        "auto_crud": true,
        "breadcrumb": "Order Set",
        "check_permission": false,
        "showMenu": true
      },
      {
        "name": "menu.print_config",
        "resource": "print_config",
        "icon": "fa fa-user-md",
        "url": "print_config",
        "auto_crud": true,
        "breadcrumb": "Print Congig",
        "check_permission": false,
        "showMenu": true
      },
      {
        "name": "menu.miscellaneous",
        "resource": "insurance_billing_miscllaneous",
        "icon": "fa fa-user",
        "url": "insurance_billing_miscllaneous",
        "auto_crud": true,
        "breadcrumb": "Miscellaneous",
        "showMenu": false
      },
    ]
  },
  {
    "name": "menu.frequency_master",
    "resource": "frequency_master",
    "icon": "fa fa-h-square",
    "url": "frequency_master",
    "auto_crud": true,
    "breadcrumb": "Frequency Master",
    "check_permission": false,
    "showMenu": true
  },
  {
    "name": "menu.allergy_master",
    "resource": "allergy_master",
    "icon": "fa fa-h-square",
    "url": "allergy_master",
    "auto_crud": true,
    "breadcrumb": "Allergy Master",
    "check_permission": false,
    "showMenu": true
  },
  {
    "name": "menu.referralWorklist",
    "resource": "emr_refer",
    "icon": "fa fa-plus-square",
    "url": "emr_refer",
    "auto_crud": true,
    "breadcrumb": "referralWorklist",
    "showMenu": false
  },
  {
    "name": "menu.clearance_status",
    "icon": "fa fa-h-square",
    "url": "clearance_status_emr",
    "auto_crud": false,
    "showMenu": true
  },
  {
    "name": "menu.intake_output_chart_master",
    "resource": "intake_output_chart_master",
    "icon": "fa fa-h-square",
    "url": "intake_output_chart_master",
    "auto_crud": true,
    "breadcrumb": "Intake Output Chart Master",
    "check_permission": false,
    "showMenu": true
  },
  {
    "name": "menu.medication_type_master",
    "resource": "medication_type_master",
    "icon": "fa fa-h-square",
    "url": "medication_type_master",
    "auto_crud": true,
    "breadcrumb": "Medication Type Master",
    "check_permission": false,
    "showMenu": true
  },
  {
    "name": "menu.signature_master",
    "resource": "signature_master",
    "icon": "fa fa-user-md",
    "url": "signature_master",
    "auto_crud": true,
    "breadcrumb": "Signature Master",
    "check_permission": false,
    "showMenu": true
  },
  {
    "name": "menu.diagnosis_classification",
    "resource": "diagnosis_classification",
    "icon": "fa fa-tag",
    "url": "diagnosis_classification",
    "auto_crud": true,
    "breadcrumb": "Dianosis ICD",
    "check_permission": true,
    "showMenu": true
  },
  {
    "name": "menu.ophthalmic_examination_master",
    "resource": "ophthalmic_examination_master",
    "icon": "fa fa-tag",
    "url": "ophthalmic_examination_master",
    "auto_crud": true,
    "breadcrumb": "Ophthalmic Examination Master",
    "check_permission": true,
    "showMenu": true
  },
  {
    "name": "menu.route",
    "resource": "medication_route_master",
    "icon": "fa fa-tag",
    "url": "medication_route_master",
    "auto_crud": true,
    "breadcrumb": "Patient Assessment",
    "check_permission": false,
    "showMenu": false
  },
  {
    "name": "menu.route",
    "resource": "ip_ward_consumable_highly_sub_form",
    "icon": "fa fa-tag",
    "url": "ip_ward_consumable_highly_sub_form",
    "auto_crud": true,
    "breadcrumb": "Patient Assessment",
    "check_permission": false,
    "showMenu": false
  },
  {
    name: 'menu.immunization_patient',
    resource: 'immunization_patient',
    icon: 'fa fa-user',
    url: 'immunization_patient',
    auto_crud: true,
    showMenu: false,
    breadcrumb: 'immunization patient'
  },
  {
    name: 'menu.update_MLC_details',
    resource: 'update_MLC_details',
    icon: 'fa fa-user',
    url: 'update_MLC_details',
    auto_crud: true,
    showMenu: false,
    breadcrumb: 'MLC Update'
  },
  {
    name: 'menu.update_MLC_details_op',
    resource: 'update_MLC_details_op',
    icon: 'fa fa-user',
    url: 'update_MLC_details_op',
    auto_crud: true,
    showMenu: false,
    breadcrumb: 'MLC Update'
  },
  {
    "name": "menu.order_itemtype_mapping",
    "resource": "order_itemtype_mapping",
    "icon": "fa fa-tag",
    "url": "order_itemtype_mapping",
    "auto_crud": true,
    "breadcrumb": "Patient Assessment",
    "check_permission": false,
    "showMenu": false
  },
  {
    "name": "menu.mdt_format",
    "resource": "mdt_format",
    "url": "mdt_format",
    "auto_crud": true
  },
  {
    "name": "menu.mdt_board_worklist",
    "resource": "mdt_board_worklist",
    "url": "mdt_board_worklist",
    "auto_crud": true
  },
  {
    "name": "menu.verbal_order_regularization_worklist",
    "resource": "verbal_order_regularization_worklist",
    "url": "verbal_order_regularization_worklist",
    "auto_crud": true
  },
  {
    "name": "menu.mdt_requests",
    "resource": "mdt_requests",
    "url": "mdt_requests",
    "auto_crud": true
  },
  {
    name: "menu.ip_conversion_request_list",
    resource: "ip_conversion_request_list",
    url: "ip_conversion_request_list",
    auto_crud: true
  },
  {
    name: "menu.pending_ip_conversion_list",
    resource: "pending_ip_conversion_list",
    url: "pending_ip_conversion_list",
    auto_crud: true
  },
  {
    name: "menu.completed_ip_conversion_list",
    resource: "completed_ip_conversion_list",
    url: "completed_ip_conversion_list",
    auto_crud: true
  },
  {
    "name": "menu.myfeeds",
    "resource": "myfeeds_format",
    "icon": "fa fa-tag",
    "url": "myfeeds_format",
    "auto_crud": true,
    "breadcrumb": "My Feeds",
    "check_permission": false,
    "showMenu": false
  },
  {
    name: 'menu.submitted_bill',
    resource: 'insurance_billing_answered',
    icon: 'fa fa-plus-square',
    url: 'insurance_billing_answered',
    check_permission: false,
    auto_crud: true,
    showMenu: true
  },
  {
    "name": 'menu.mark_as_source_out',
    "resource": 'cryopreservation_source_out',
    "icon": 'fa fa-plus-square',
    "url": 'cryopreservation_source_out',
    "check_permission": false,
    "auto_crud": true
  },
  {
    "name": 'menu.source_out',
    "resource": 'source_out',
    "icon": 'fa fa-plus-square',
    "url": 'source_out',
    "check_permission": false,
    "auto_crud": true
  },
  {
    "name": "menu.mdt_template",
    "resource": "mdt_template",
    "url": "mdt_template",
    "auto_crud": true,
    "showMenu": false
  },
  {
        name: "menu.ip_episode_history",
        resource: "ip_episode_history",
        url: "ip_episode_history",
        auto_crud: true
  },
  {
    "name": "menu.emr_confidentiality",
    "resource": "emr_confidentiality",
    "icon": "fa fa-user-secret",
    "url": "emr_confidentiality",
    "auto_crud": true,
    "showMenu": true,
    "check_permission": true
  },
  {
    "name": "menu.emr_confidentiality_exception_user",
    "resource": "emr_confidentiality_exception_user",
    "icon": "fa fa-user-secret",
    "url": "emr_confidentiality_exception_user",
    "auto_crud": true,
    "showMenu": true,
    "check_permission": true
  },
]




